module.exports = __webpack_public_path__ + "static/media/icon_smart_message.2fc985f4.svg";